import React from 'react';
import PelletsRouter from './PelletsRouter';

export default function PelletsPage() {
  return <PelletsRouter />;
}
